import { useMutation } from '@apollo/client'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { mapGraphQLErrors } from 'providers/graphql'
import { CommonProps } from '../../../types'
import { Schema } from '../../schema'
import { toDTO } from './api/mapper'
import { CONNECT_BANNER_AND_OUTSTREAM_TO_GAM } from './api/mutation'
import { Data } from './api/types'
import { UseConnectBannerAndOutstreamToGam } from './types'

export const useConnectBannerAndOutstreamToGam = ({
  setIsDialogOpen,
}: Pick<CommonProps, 'setIsDialogOpen'>): UseConnectBannerAndOutstreamToGam => {
  const { workspaceId } = useWorkspaceParam()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'googleAdManagerConnection.setupPrebidStack.form',
  })
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const [mutate, { loading }] = useMutation(CONNECT_BANNER_AND_OUTSTREAM_TO_GAM, {
    onCompleted: ({ connectBannerAndOutstreamToGam: { errors } }: Data): void => {
      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('notification.error'), { variant: 'error' })
      } else {
        enqueueSnackbar(t('notification.success'), { variant: 'success' })
      }

      setIsDialogOpen(false)
    },
    // TODO: After moving to Tanstack refetch only 'getFreshStatusAndErrorForGamSetupOrders'
    refetchQueries: ['getGoogleAdManagerSetupOrders'],
  })

  const connect = (data: Schema): void =>
    void mutate({
      variables: {
        input: {
          ...toDTO(data),
          workspaceId,
        },
      },
    })

  return { connect, errors, loading }
}
